module.exports = __webpack_public_path__ + "static/fonts/NunitoSans-Variable.303dbed.ttf";